import React, { useEffect, useState } from "react";
import AddDetails from "./AddDetails";
import EditDetails from "./EditDetails";
import GlobalDeleteModal from "../../../layout/admin/partials/GlobalDeleteModal";
import { useSearchParams } from "react-router-dom";
import { showError, showSuccess } from "../../../utils/toastUtils";
import mpAPI from "../../../api/admin/mpApi";
import gameAPI from "../../../api/admin/gameApi";

function Media() {
  const [events, setEvents] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [editData, setEditData] = useState(null);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [deleteTable, setDeleteTable] = useState(null);

  useEffect(() => {
    fetchGameData();
  }, []);

  const fetchGameData = async () => {
    const res = await gameAPI.getList();
    if (res.code === 200) {
      setEvents(res.data);
    } else {
      setEvents([]);
    }
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    setSearchParams(params);
  };

  const handleOpenDeleteModal = (id, table) => {
    setDeleteId(id);
    setDeleteTable(table);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
            <div>
              <h4 className="mb-1">Event's Media</h4>
              <h6 className="text-muted">
                Upload Pictures, Video of Games
              </h6>
            </div>
            <div className="gap-2 d-flex align-items-center flex-wrap">
              <button
                className="btn btn-primary mt-2 mt-md-0"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
                onClick={() => setShowOffcanvas(true)}
              >
                <i className="ti ti-circle-plus me-1" />
                Add Media
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Athletics Championship</h5>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-2 mb-3">
                      <a
                        href="assets/img/media/img-01.jpg"
                        className="image-popup"
                      >
                        <img
                          src="https://thebridge.in/h-upload/2023/06/30/48367-jyothi-yarraji.webp"
                          className="img-fluid"
                          alt="image"
                        />
                      </a>
                    </div>
                    <div className="col-md-2 mb-3">
                      <a
                        href="assets/img/media/img-02.jpg"
                        className="image-popup"
                      >
                        <img
                          src="https://img.olympics.com/images/image/private/t_s_pog_staticContent_hero_xl_2x/f_auto/primary/ccqeyuxehm4jjfoco1qu"
                          className="img-fluid"
                          alt="image"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Cricket Championship</h5>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-2 mb-3">
                      <a
                        href="assets/img/media/img-03.jpg"
                        className="image-popup-desc"
                        data-title="Title 01"
                        data-description="Lorem ipsum dolor sit amet, consectetuer adipiscing elit"
                      >
                        <img
                          src="https://static01.nyt.com/images/2023/10/03/multimedia/03xp-cricket1-whzj/03xp-cricket1-whzj-articleLarge.jpg?quality=75&auto=webp&disable=upscale"
                          className="img-fluid"
                          alt="work-thumbnail"
                        />
                      </a>
                    </div>
                    <div className="col-md-2 mb-3">
                      <a
                        href="assets/img/media/img-04.jpg"
                        className="image-popup-desc"
                        data-title="Title 02"
                        data-description="Lorem ipsum dolor sit amet, consectetuer adipiscing elit"
                      >
                        <img
                          src="https://images.indianexpress.com/2025/03/KL-RAHUL-CHAMPIONS-TROPHY-FINAL.jpg?w=414"
                          className="img-fluid"
                          alt="work-thumbnail"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        {showOffcanvas && <AddDetails onSuccess={fetchGameData} />}
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasEditRight"
        aria-labelledby="offcanvasEditRightLabel"
      >
        {editData && <EditDetails data={editData} onSuccess={fetchGameData} />}
      </div>

      <GlobalDeleteModal
        id={deleteId}
        table={deleteTable}
        onDeleted={fetchGameData}
      />
    </>
  );
}

export default Media;
